import t from '../translate'
import { useFormikContext } from 'formik'
import React, { useState, useMemo, useEffect } from 'react'
import buildSerializeApplication from "../utils/serialize-application";
import programSchema from '../schema/program'
import dataSchema from '../schema/data'
import sendSchema from '../schema/send';
import * as yup from 'yup'
import i18n from '../i18n'
import de_confirmation_image from '../../images/thanks-confirmation-step.de.jpg';
import en_confirmation_image from '../../images/thanks-confirmation-step.en.jpg';

const ResponseContainer = ({ success }) => {
  const getConfirmationImage = (lang) => {
    if (lang === 'en') {
      return en_confirmation_image
    } else {
      return de_confirmation_image
    }
  }
  return <>
    <div style={{ display: success === null ? 'block' : 'none' }}>
      <span>{t('confirmation.sending')}</span>
    </div>
    <div style={{ display: success === false ? 'block' : 'none' }}>
      <span>{t('confirmation.error')}</span>
    </div>
    <div style={{ display: success ? 'block' : 'none' }}>
      <p>
        <img src={getConfirmationImage(i18n.language)} width={'100%'} style={{'maxWidth': '940px'}}/>
      </p>
      <br></br>
      <p dangerouslySetInnerHTML={{ __html: t('confirmation.text') }}></p>
    </div>
  </>;
};

export default function ConfirmationStep ({program, programs, countries, locations, deleteCache}) {
  const { values } = useFormikContext()
  const [success, setSuccess] = useState(null);

  let schema = useMemo(
    () => {
      let shape = {}
      shape.program = programSchema(program, programs)
      shape.data = dataSchema(program, programs, countries, locations)
      shape.send = sendSchema(program, programs, countries, locations)
      return yup.object().required().shape(shape)
    }
  );
  const serializeApplication = useMemo(
    () => buildSerializeApplication(schema),
    [schema]
  );

  const hideMenu = () => {
    const menus = document.querySelectorAll('.menu');
    menus.forEach(menu => {
        menu.style.display = 'none';
    });
  }

  useEffect(() => {
    let data = new FormData();
    let attachmentTypes = ['resume', 'grades', 'miscellaneous'];

    attachmentTypes.forEach((type) => {
      if (Array.isArray(values.send?.attachments?.[type])) {
        values.send.attachments[type].forEach((attachment, index) => {
          data.append(`${type}[${index}][description]`, attachment.description);
          data.append(`${type}[${index}][category]`, attachment.category);
          data.append(`${type}[${index}][file]`, attachment.file);
          data.append(`${type}[${index}][fileName]`, attachment.fileName);
          data.append(`${type}[${index}][fileSize]`, attachment.fileSize);
          data.append(`${type}[${index}][fileType]`, attachment.fileType);
        });
      }
    });
    
    data.append("firstName", values.data?.personal?.information?.firstName);
    data.append("lastName", values.data?.personal?.information?.lastName);

    fetch("/api/application/upload", {
      method: "POST",
      body: data
    }).then(response => {
      if(response.ok) {
        response.json().then((response) => {
          values.attachmentsFile = response.attachmentsFile;
          values.language = i18n.language;
          fetch("/api/application/applications", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: serializeApplication(values)
          }).then((response) => {
            if (response.ok) {
              values.sessionExpired = true;
              deleteCache(values);
              hideMenu();
              setSuccess(true);
            } else {
              throw new Error('Something went wrong');
            }
          })
          .catch((error) => {
            setSuccess(false);
          });
        });
      } else {
        setSuccess(false);
      }
    });
  }, []);

  return <div className="confirmation">
      <div className="confirmation-section">
        <ResponseContainer success={success}/>
    </div>
  </div>
}
